// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1oZky","inputWrap":"CustomTip_inputWrap__1leY0"};